export default __webpack_public_path__ + "static/backgroundGallery-3c1c48a0277b8c535a6c1ddda29e0216.jpg";